import { AlertBanner } from "@molecules"
import { AlertBannerProps } from "@molecules/AlertBanner/AlertBanner.types"

import useOTPForm from "@organisms/OTPForm/OTPForm.store"

export default function OTPAlertBanner(props: Partial<AlertBannerProps>) {
    const { nonFieldErrorMessage, isShowingErrorMessage } = useOTPForm()

    if (nonFieldErrorMessage && isShowingErrorMessage) {
        return <AlertBanner type="banner" message={nonFieldErrorMessage} status="error" fullWidth={true} {...props} />
    } else {
        return null
    }
}
